import { motion } from "framer-motion";
import { Target, MagnifyingGlass, PenNib, ArrowsClockwise, ChartLineUp } from "@phosphor-icons/react";
import { useScene } from "@/context/SceneContext";
import { HOME } from "@/constants/testIds";

const FEATURES = [
  {
    icon: Target,
    title: "Positioning & Product-Marketing",
    desc: "Audience segments, pain points, and differentiators mapped before a word of copy is written.",
    focus: "violet",
  },
  {
    icon: MagnifyingGlass,
    title: "App Store Optimization (ASO)",
    desc: "Titles, subtitles, keyword fields, and descriptions tuned for search visibility and CRO.",
    focus: "amber",
  },
  {
    icon: PenNib,
    title: "Copywriting & Content",
    desc: "High-converting ad copy, onboarding emails, launch announcements, push sequences.",
    focus: "violet",
  },
  {
    icon: ArrowsClockwise,
    title: "Growth & Retention Loops",
    desc: "Referral loops, churn-prevention triggers, lead magnets, automated re-engagement flows.",
    focus: "amber",
  },
  {
    icon: ChartLineUp,
    title: "Low-Budget Paid Testing",
    desc: "Structured $5-$10/day A/B tests with creative hooks — never a wasted dollar upfront.",
    focus: "violet",
  },
];

const FeatureGrid = () => {
  const { setFocus } = useScene();

  return (
    <section className="relative py-24 sm:py-32 px-6 lg:px-12">
      <div className="max-w-7xl mx-auto">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#7C93B8] mb-4">Core Marketing Frameworks</p>
        <h2 className="font-display text-4xl sm:text-5xl font-bold tracking-tight leading-none mb-16 max-w-2xl">
          Five procedural frameworks, applied to every campaign.
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {FEATURES.map((f, i) => {
            const Icon = f.icon;
            return (
              <motion.div
                key={f.title}
                data-testid={HOME.featureCard(i)}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.1 }}
                onMouseEnter={() => setFocus(f.focus)}
                onMouseLeave={() => setFocus("neutral")}
                className="tracing-border glass-panel rounded-2xl p-8 hover:-translate-y-1 transition-transform duration-300 cursor-default"
              >
                <Icon size={28} weight="duotone" className="text-white mb-6" />
                <h3 className="font-display text-lg font-bold mb-3">{f.title}</h3>
                <p className="text-sm text-white/50 leading-relaxed">{f.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeatureGrid;
